export function JamesTypingIndicator() {
  return (
    <div className="flex items-center gap-1 px-3 py-2">
      <div className="flex gap-1">
        <span className="h-2 w-2 rounded-full bg-text-tertiary animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="h-2 w-2 rounded-full bg-text-tertiary animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="h-2 w-2 rounded-full bg-text-tertiary animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
      <span className="text-body-xs text-text-tertiary ml-2">James is thinking...</span>
    </div>
  );
}
